import { useHandler } from "@redotech/react-util/hook";
import {
  OmsItemQuantityConditionStep,
  OmsPackageWeightOzConditionStep,
  OmsTotalValueConditionStep,
} from "@redotech/redo-model/advanced-flow/oms/conditions";
import { OmsConditionStep } from "@redotech/redo-model/advanced-flow/steps";
import { memo } from "react";
import { DeepPartial } from "..";
import { WeightStepInput } from "../common/weight-step-input";

export const OmsWeightStepInput = memo(function OmsWeightStepInput({
  step,
  setStep,
}: {
  step:
    | DeepPartial<OmsTotalValueConditionStep>
    | DeepPartial<OmsPackageWeightOzConditionStep>
    | DeepPartial<OmsItemQuantityConditionStep>;
  setStep: (step: DeepPartial<OmsConditionStep>) => void;
}) {
  const setOunces = useHandler((matchValue: number) => {
    setStep({ ...step, matchValue });
  });
  return (
    <WeightStepInput matchValue={step.matchValue} setMatchValue={setOunces} />
  );
});
